import { Component, OnInit } from '@angular/core';
import {MdDialogRef} from '@angular/material';
import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import {Router, ActivatedRoute, Params } from '@angular/router';


import {ListingService } from '../listing.service';

@Component({
  selector: 'app-check-payment',
  templateUrl: './check-payment.component.html',
  styleUrls: ['./check-payment.component.css','../admin.css', '../../app.component.css'],
  providers: [ListingService]
})
export class CheckPaymentComponent implements OnInit {
  payDetail: any;
  title: string;
  message: string;
  checkForm: any;
  spinner: boolean = false;
  errorMessage: any;
  pending: any;
  amount: any;
  eId :any;

  constructor(private router:Router,private pageTitle: Title, public dialogRef: MdDialogRef<CheckPaymentComponent>, private formBuilder: FormBuilder, private ListingService: ListingService) {
    pageTitle.setTitle(this.title);
    this.checkForm = this.formBuilder.group({
      "userId": ['', Validators.required],
      "eventId":['', Validators.required],
      "eventUserId":['', Validators.required],
      "pending": ['', Validators.required],
      "checkNo": ['', Validators.required],
      "amount": ['', Validators.required],
      "comments": ['', Validators.required],
    });
  }

  ngOnInit() {


    this.eId=localStorage.getItem('eventId');
    if(this.eId) {
      this.checkForm.controls['userId'].patchValue(this.payDetail.userId);
      this.checkForm.controls['eventUserId'].patchValue(this.payDetail.eventUserId);
      this.checkForm.controls['eventId'].patchValue(this.eId);
      this.checkForm.controls['pending'].patchValue(this.payDetail.pendingAmt);
      this.pending=this.payDetail.pendingAmt;
    }else{
      this.router.navigate(['./admin-event-listing']);
    }
  }

  addCheckPayment(){
    this.spinner = true;
    this.checkForm.controls['userId'].patchValue(this.payDetail.userId);
    if (this.checkForm.dirty && this.checkForm.valid) {
      this.ListingService.addCheckAmt(this.checkForm.value)
          .subscribe(
           response => {
	    this.spinner = false;
            this.errorMessage = '';
            this.dialogRef.close(response.message);
           },
           error => {
	    this.spinner = false;
            this.errorMessage = <any>error;
           }
      );
    }
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/check-payment/check-payment.component.ts